import { Merchant } from 'apis/restaurant-api/merchant-admin/merchant/types';

import { useOpenKybProcesses } from './useOpenKybProcesses';

export const useUnverifiedMerchants = ({ merchants }: { merchants: Merchant[] }) => {
  const { openKybProcesses } = useOpenKybProcesses({ merchants });
  return {
    unverifiedMerchants:
      merchants?.filter(merchant => openKybProcesses?.find(process => merchant.itemid.$oid === process.merchantId)) ||
      [],
  };
};
